// extracted by mini-css-extract-plugin
export default {"panelContainer":"Panel-module__panelContainer__FpGTB"};